import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ForYouSection } from './components/ForYouSection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { FAQSection } from './components/FAQSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (typeof window.fbq === 'function') return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '2170351770441900');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen w-full bg-[#111111] text-white overflow-x-hidden font-sans selection:bg-brand-yellow selection:text-black" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ForYouSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <FAQSection data-id="element-5" />
      <PricingCTA data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}